import React from 'react';

import Container from 'components/common/container';
import Image from 'components/common/image';
import ResponsiveBox from 'components/common/responsive-box';
import Section from 'components/common/section';
import { PortableText } from 'framework/sanity/portable-text';
import { mobile, tablet } from 'utils/media';

import { Background, Title, Tree, TreeContainer } from './styles';
import { CopyTreeProps } from './types';

const borderImageRatio = { [mobile]: 0.29, [tablet]: 0.1465 };

export default function CopyTree({
  colorScheme,
  borderImage,
  title,
  sections,
}: CopyTreeProps) {
  return (
    <Background colorScheme={colorScheme}>
      {borderImage ? (
        <ResponsiveBox aspectRatio={borderImageRatio}>
          <Image
            sizes="100vw"
            alt=""
            aspectRatio={borderImageRatio}
            src={borderImage}
          />
        </ResponsiveBox>
      ) : null}
      <Section>
        <Container inset>
          {title ? (
            <Title>
              <PortableText blocks={title} />
            </Title>
          ) : null}
          {sections?.length ? (
            <TreeContainer>
              <Tree>
                {sections.map((section) => (
                  <div key={section._key}>
                    <PortableText blocks={section.body} />
                  </div>
                ))}
              </Tree>
            </TreeContainer>
          ) : null}
        </Container>
      </Section>
    </Background>
  );
}
